import React from 'react';
import PropTypes from 'prop-types';
import { translationPropType } from '@eb/i18n';

import FormSubmitButton from '../FormSubmitButton';
import PasswordField from '../PasswordField';

import { formValidate } from '@eb/eds-utils';
import {
    newSignupValidate as validate,
    asyncValidateConfirmEmail as asyncValidate,
} from '../utils';

import { SET_PASSWORD_FORM } from '../../constants';

class ResetPasswordForm extends React.Component {
    static propTypes = {
        handleSubmit: PropTypes.func.isRequired,
        buttonCTA: translationPropType,
        email: PropTypes.string,
        locale: PropTypes.string,
        recaptcha2PublicKey: PropTypes.string,
        showCaptcha: PropTypes.bool,
        fp: PropTypes.bool,
        showNotification: PropTypes.func,
        clearNotification: PropTypes.func,
        /* Props Provided Via ReduxForm */
        submitFailed: PropTypes.bool,
        submitSucceeded: PropTypes.bool,
        submitting: PropTypes.bool,
    };

    componentWillReceiveProps({ submitting, submitFailed, error }) {
        const { showNotification, clearNotification } = this.props;

        /*If the form has an error and submit failed, attempt
        to display a notification*/
        if (submitFailed && error) {
            showNotification(error);
        }

        /*We want to limit only one error notification to
        appear per form submission if the user has dismissed it.
        So each time submitting is true, then reset the flag.*/
        if (submitting) {
            clearNotification();
        }
    }

    componentWillUnmount() {
        const { clearNotification } = this.props;

        clearNotification();
    }

    render() {
        const {
            handleSubmit,
            buttonCTA,
            submitting,
            submitSucceeded,
            submitFailed,
        } = this.props;

        const submitDisabled = submitting || submitSucceeded;

        return (
            <form
                onSubmit={handleSubmit}
                noValidate="novalidate"
                className="eds-fx--fade-in eds-fx--delay-2 eds-l-pad-bot-5"
            >
                <PasswordField submitFailed={submitFailed} />
                <FormSubmitButton
                    submitDisabled={submitDisabled}
                    buttonClasses="eds-fx--fade-in-down eds-fx--delay-1 eds-l-mar-top-8"
                    buttonCTA={buttonCTA}
                />
            </form>
        );
    }
}

export default formValidate({
    validate,
    asyncValidate,
    form: SET_PASSWORD_FORM,
    touchOnChange: true,
    touchOnBlur: false,
})(ResetPasswordForm);
